function makeTanstackQuery(config) {
  const queryFactory = (input) => {
    return {
      queryKey: config.queryKey(input),
      queryFn: () => config.queryFn(input),
      ...config.defaultQueryConfig
    };
  };
  return Object.freeze({
    useQueryKey(input) {
      return config.useQueryInput ? config.useQueryInput(queryFactory, input).queryKey : queryFactory(input).queryKey;
    },
    useQueryConfig(input) {
      const resolvedConfig = config.useQueryInput ? config.useQueryInput(queryFactory, input) : queryFactory(input);
      return {
        ...resolvedConfig,
        ...input == null ? void 0 : input.queryConfig
      };
    },
    queryKey(input) {
      return queryFactory(input).queryKey;
    },
    queryConfig(input) {
      return queryFactory(input);
    }
  });
}

export { makeTanstackQuery };
//# sourceMappingURL=abstraction.make-query.js.map
